import { type IGridStrategy } from './abstract.strategy';
import { EventEmitter } from '../../../system/classes/event-emitter';

export class PageGridStrategy extends EventEmitter implements IGridStrategy {
    constructor(
        private strategy: IGridStrategy,
        header = 66
    ) {
        super();
        this.addHeader(header);
    }

    public getGridHeight(): number {
        return this.strategy.getGridHeight();
    }

    public getInnerGridHeight(): number {
        return this.strategy.getInnerGridHeight();
    }

    public getGridPageAmount(): number {
        return this.strategy.getGridPageAmount();
    }

    public addHeader(headerHeight = 0): void {
        this.strategy.addHeader(headerHeight);
    }

    public on(event, listener, options = null) {
        return this.strategy.on(event, listener, options);
    }

    public showPagination() {
        return this.strategy.showPagination();
    }

    getCssClasses() {
        return this.strategy.getCssClasses();
    }

    isStretchable() {
        return this.strategy.isStretchable();
    }

    public usesAllItems(): boolean {
        return this.strategy.usesAllItems();
    }

    public detach() {
        this.strategy.detach();
    }
    public setGridElement(gridElement: HTMLElement): void {
        this.strategy.setGridElement(gridElement);
    }
}
